/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PreviousDamages } from './previousDamages';

/**
 * Represents a motor vehicle partial comprehensive insurance.   (german: Kfz Teilkasko)   (bipro-kraftfahrt::Fahrzeugteilversicherung)
 */
export interface PreviousPartialComprehensiveInsurance {
  /**
   * Technical discriminator for the concrete elementary product type.
   */
  productType: string;
  damages?: PreviousDamages;
}
